<template>
  <div class="login-container">
    <h1>{{ $t("FormLogin.login") }}</h1>
    <p
      v-if="userStore.loginFailed"
      class="text-sm text-orange-500 break-normal"
    >
      {{ $t("FormLogin.loginError") }}
    </p>
    <el-form label-position="top" class="login-form">
      <el-form-item class="mt-12">
        <template #label>
          <label>
            {{ $t("FormLogin.username") }}
            <el-input
              ref="userNameInput"
              v-model="username"
              autofocus
              :placeholder="$t('FormLogin.userName')"
              @keyup.enter="doLogin"
            />
            <span
              v-if="!username.length && triedToLogin"
              class="inline-block text-sm text-orange-500 break-normal"
            >
              {{ $t("FormLogin.userValidation") }}
            </span>
          </label>
        </template>
      </el-form-item>
      <el-form-item class="mb-4">
        <template #label>
          <label>
            {{ $t("FormLogin.password") }}
            <el-input
              v-model="password"
              :placeholder="$t('FormLogin.password')"
              type="password"
            />
            <span
              v-if="!password.length && triedToLogin"
              class="inline-block text-sm text-orange-400 break-normal"
            >
              {{ $t("FormLogin.passwordValidation") }}
            </span>
          </label>
        </template>
      </el-form-item>
      <router-link 
        :to="{ name: 'forgot-password', query: { lang: locale }}" 
        class="text-gray-600 hover:text-gray-900 underline"
      >
        {{ $t("FormLogin.forgotPassword") }}
      </router-link>
      <div class="flex justify-start mt-8">
        <el-button
          class="has-icon"
          :disabled="!username.length || !password.length"
          size="default"
          @click="doLogin"
        >
          <SvgIcon name="check-circle" />
          {{ $t("FormLogin.login") }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>
<script setup>
import { onMounted, ref, nextTick } from "vue";
import { useUserStore } from "@/store/User";
import { useRoute, useRouter } from "vue-router";

const userStore = useUserStore();
const route = useRoute();
const router = useRouter();

const triedToLogin = ref(false);
const username = ref("");
const password = ref("");
const userNameInput = ref(null);

const doLogin = async () => {
  triedToLogin.value = true;
  const loginData = {
    username: username.value,
    password: password.value,
  };
  if (username.value.length && password.value.length) {
    await userStore.login(loginData, route, router);
    if (userStore.isLoggedIn) {
      const redirectPath = route.query.redirect || '/';
      router.push(redirectPath);
    }
  }
};

onMounted(() => {
  //only trigger when we are sure the html is applied
  nextTick(() => {
    //grab the username input and focus it
    userNameInput.value.$el.getElementsByTagName("input")[0].focus();
  });
});
</script>

<style lang="postcss" scoped>
.login-container {
  @apply w-full;
}

@screen md {
  .login-container {
    @apply w-1/2 mx-auto;
  }
}

.login-form {
  @apply w-full;
}

@screen md {
  .login-form {
    @apply w-full;
  }
}
</style>
